<template>
    <div>
        <!-- 头部logo -->
        <head-tou/>
        <div class="w">
            <!-- 导航栏 -->
            <navi-gation/>
            <div class="box">
                <div class="login-tab">
                    <div class="tab-box" :class="{'tab-box-active': item.code == tab_code}"
                         @click.stop="cut_tab(item,index)" v-for="(item,index) in tab_list"
                         :key="index">{{item.name}}
                    </div>
                </div>
                <div class="login-content" v-show="tab_code==1">
                    <van-form>
                        <van-field
                                v-model="login_phone"
                                maxlength="11"
                                placeholder="请输入手机号码"
                                :rules="[
                                            { required: true },
            {
              pattern: /^1[3|5|6|7|8|9]\d{9}$/,
              message: '请输入正确的手机号码',
            },
                                ]"
                        >
                            <i slot="left-icon">
                                <img
                                        class="shimingyanzheng"
                                        src="@/assets/shimingyanzheng.png"
                                        alt
                                />
                            </i>
                        </van-field>
                        <van-field
                                v-model="login_password"
                                clearable
                                placeholder="请输入密码"
                                type="password"
                                maxlength="16"
                                :rules="[
              [
                { required: true, message: '请输入密码' },
                {
                  min: 6,
                  max: 16,
                  message: '请输入6到16位的密码',
                },
              ],
            ]"
                        >
                            <i slot="left-icon">
                                <img class="mima" src="@/assets/mima.png" alt/>
                            </i>
                        </van-field>

                        <!-- 提交按钮 -->
                        <div>
                            <van-button
                                    color="#2AA9B5"
                                    block
                                    native-type="submit"
                                    @click="phone_login"
                            >登录
                            </van-button
                            >
                        </div>
                    </van-form>
                </div>
                <div class="login-content" v-show="tab_code==2">
                    <van-form>
                        <van-field
                                v-model="numberId"
                                maxlength="19"
                                placeholder="请输入身份证号码"
                                :rules="[{ required: true }]"
                        >
                            <i slot="left-icon">
                                <img
                                        class="shimingyanzheng"
                                        src="@/assets/shimingyanzheng.png"
                                        alt
                                />
                            </i>
                        </van-field>
                        <van-field
                                v-model="password"
                                clearable
                                placeholder="请输入密码"
                                type="password"
                                maxlength="16"
                                :rules="[
              [
                { required: true, message: '请输入密码' },
                {
                  min: 6,
                  max: 16,
                  message: '请输入6到16位的密码',
                },
              ],
            ]"
                        >
                            <i slot="left-icon">
                                <img class="mima" src="@/assets/mima.png" alt/>
                            </i>
                        </van-field>
                        <div class="block">
                            <span class="demonstration">选择年份:</span>
                            <van-checkbox v-model="value3">2020年</van-checkbox>
                            <!--            <el-date-picker-->
                            <!--              @change="change"-->
                            <!--              v-model="value3"-->
                            <!--              type="year"-->
                            <!--              placeholder="选择年份"-->
                            <!--            >-->
                            <!--            </el-date-picker>-->
                            <van-checkbox v-model="checked">补学</van-checkbox>
                        </div>

                        <!-- 提交按钮 -->
                        <div>
                            <van-button
                                    color="#2AA9B5"
                                    block
                                    native-type="submit"
                                    @click="login"
                            >登录
                            </van-button
                            >
                        </div>
                    </van-form>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <navigation-button/>
    </div>
</template>

<script>
  import HeadTou from '@/components/hard.vue'
  import NavigationButton from '@/components/navigationbutton.vue'
  import NaviGation from './components/navigation.vue'
  import { formatTime } from '../../utils'

  export default {
    name: 'pharmacist',
    components: {
      HeadTou,
      NavigationButton,
      NaviGation,
    },
    data () {
      return {
        login_phone: '',
        login_password: '',
        tab_code: 2,
        tab_list: [
          {
            name: '手机登录',
            code: 1
          },
          {
            name: '药师登录',
            code: 2
          }
        ],
        // 手机号
        phone: '',
        // 密码
        password: '',
        //   身份证号码
        numberId: '',
        show: false,
        //   补学复选框
        checked: false,
        //   选择的年份
        value3: '',
      }
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    methods: {
      cut_tab (item, index) {
        this.tab_code = item.code
      },
      change (e) {
        // console.log(e);
      },
      login () {
        if(!this.checked && !this.value3){
          return this.API.SMessage('请选择年份/补学')
        }
        if (!this.numberId) {
          return this.API.SMessage('请输入身份证号码')
        }
        if (!this.password) {
          return this.API.SMessage('请输入密码')
        }
        this.API.post('login/user_acc-phar_login', {
          id_card: this.numberId,
          user_pwd: this.password,
          in_year: this.value3 ? 2020 : 0,
          is_buxue: this.checked ? 1 : 0
        }).then((res) => {
          console.log(res)
          if (res.code === 10010) {
            localStorage.setItem('token', res.data.token)
            if (res.data.course_status) {
              this.$router.push('/personal')
            } else {
              this.$router.push('/pharmacist-course')
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning',
            })
          }
        })
      },
      phone_login () {
        try {
          this.API.post('login/user_acc-login_pass', {
            user_acc: this.login_phone,
            user_pwd: this.login_password,
          }).then((data) => {
            if (data.errno == 0) {
              this.$message({
                showClose: true,
                message: '登入成功',
                type: 'success',
              })
              localStorage.setItem('token', data.data.token)
              this.$router.push('/')
            } else {
              this.$message({
                showClose: true,
                message: data.message,
                type: 'error',
              })
            }
          })
        } catch (err) {
          console.log(err)
        }
      }
    },
    watch:{
      checked: function () {
        if (this.checked) {
          this.value3 = false
        } else{
        }
      },
      value3: function () {
        if (this.value3) {
          this.checked = false
        } else{
        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .login-tab {
        display: flex;
        justify-content: center;
        margin: 20px 0;

        .tab-box {
            text-align: center;
            width: 40%;
            padding: 5px 10px;
            cursor: pointer;
        }

        .tab-box-active {
            border-bottom: 4px solid #2aa9b5;
        }
    }

    .w {
        width: 100%;
    }

    .box {
        height: 571px;
        width: 519px;
        margin: auto;

        .licensed {
            text-align: center;
            height: 24px;
            font-size: 23px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #343434;
            line-height: 25px;
            margin: 83px 0 44px 0;
        }
    }

    i {
        .mima {
            width: 26px;
            height: 30px;
            margin-right: 18px;
        }

        .shimingyanzheng {
            width: 33px;
            height: 26px;
            margin-right: 10px;
        }
    }

    /deep/ .van-field {
        width: 519px;
        height: 63px;
        border: 1px solid #ccc;
        margin-bottom: 20px;
    }

    /deep/ .van-button {
        width: 519px;
        height: 57px;
        background: #2aa9b5;
        border-radius: 7px;
    }

    .block {
        margin-bottom: 41px;
        margin-top: 25px;
    }

    .van-checkbox {
        display: inline-block;
        position: relative;
        top: 8px;
    }

    /deep/ .van-checkbox__icon {
        margin-left: 36px;
        display: inline-block;
    }

    /deep/ .van-checkbox__icon--checked .van-icon-success {
        background-color: #2aa9b5;
    }
</style>
